const hostname = window.location.hostname;
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";
const projectId =
  window.location.origin === "https://teacher-read.web.app"
    ? "teacher-read"
    : "teacher-read-dev";

// Local Vue dev uses deployed Cloud Functions unless VUE_APP_USE_FUNCTIONS_EMULATOR=true
const useFunctionsEmulator =
  isLocal && process.env.VUE_APP_USE_FUNCTIONS_EMULATOR === "true";

export const BASE_URL = useFunctionsEmulator
  ? `http://localhost:5001/${projectId}/us-central1`
  : `https://us-central1-${projectId}.cloudfunctions.net`;
